import React from 'react'
import { useParams } from 'react-router'
import { components } from 'cng-web-lib'

import FormProperties from './CiaFtaMapping_FormProperties'
import CIAFtaMappingApiUrls from 'src/apiUrls/CIAFtaMappingApiUrls'

const { form: { CngEditForm } } = components

function EditPage({ history, showNotification }) {

    const { id } = useParams()

    return (
        <CngEditForm
            fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
            history={history}
            showNotification={showNotification}
            bodySection={
                <FormProperties.Fields
                    disabled={false}
                    isNotEditable={true}
                    showNotification={showNotification}
                    id={id}
                />
            }
            formikProps={FormProperties.formikProps}
            toClientDataFormat={FormProperties.toClientDataFormat}
            toServerDataFormat={FormProperties.toServerDataFormat}
            fetch={{ url: CIAFtaMappingApiUrls.GET }}
            update={{ url: CIAFtaMappingApiUrls.PUT }}
            id={id}
        />
    )
}

export default EditPage